/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import App from './views/App'
import './registerServiceWorker'
import Vue from 'vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import VueCurrencyFilter from 'vue-currency-filter'
import { BootstrapVue } from 'bootstrap-vue'
import vSelect from "vue-select";
import VueFloatLabel from 'vue-float-label'

Vue.component("v-select", vSelect);
require('./bootstrap')

Vue.use(VueFloatLabel)

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.use(Vuelidate)
Vue.use(BootstrapVue)

Vue.config.productionTip = false;
window.axios = require ('axios');

const app = new Vue({
  created(){
    const html = document.documentElement
    html.setAttribute('lang', 'de')
  },
  store,
  router,
  render: h => h(App)
}).$mount('#app');



